import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "0807322f-896b-4213-a886-b4141625fe83", content: "The DnT = 50 dB and R’ = 50 dB.", options: {} },
  { id: "960a814c-0a6b-4a83-ae7b-e4d42f8ff4dc", content: "The DnT = 52 dB and R’ is higher.", options: {} },
  { id: "305a5524-64e7-4f30-9a54-3cc57e560c8c", content: "The DnT = 50 and R’ is lower.", options: {} },
  { id: "ec874b06-0e77-4774-9421-074461be3806", content: "The DnT = 50 dBA and R’ cannot be determined.", options: {} },
];

export const task: Task = {
  id: "870a18bb-133b-42c0-a340-fd85bef0a64c",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["ec874b06-0e77-4774-9421-074461be3806"],
};
